import TYPES from '../actions/types';

const INITIAL_STATE = {
  loadingFormSearch: false,
  dataRows: [],
  totalOfRows: 0,
  getListError: false,
};

export default function(state = INITIAL_STATE, action) {
  switch(action.type) {
    case TYPES.todoSuccess:
      return {
        ...state,
        dataRows: action.payload.data,
        totalOfRows: action.payload.total,
        getListError: false,
      };

    case TYPES.todoError:
      return {
        ...state,
        getListError: true,
        loadingFormSearch: !state.loadingFormSearch,
      }

    case TYPES.todoLoading:
      return {
        ...state,
        getListError: false,
        loadingFormSearch: !state.loadingFormSearch,
      };

    case TYPES.updateList:
      return {
        ...state,
        dataRows: state.dataRows.filter(item => item.id !== action.payload.id),
        totalOfRows: state.totalOfRows - 1,
      }

    default:
      return state;
  }
};
